export default {
  pinnable: false,
  allowConnectToDB: true,
  skipInQuickEditPanel: true,
};
